import {
  locationIdFormat,
  returnsCenterIdFormat,
} from "@redotech/redo-ids-cockroach";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const TeamLocationSchema_ = z.object({
  id: locationIdFormat.schema,
  name: z.string(),
  street1: z.string().nullable(),
  street2: z.string().nullable(),
  city: z.string().nullable(),
  state: z.string().nullable(),
  postalCode: z.string().nullable(),
  country: z.string().nullable(),
  isActive: z.boolean().nullable(),
  isReturnsCenter: z.boolean().nullable(),
  returnsCenterId: returnsCenterIdFormat.schema.nullable(),
});

export const TeamLocationSchema: z.ZodType<TeamLocation> = TeamLocationSchema_;
export interface TeamLocation extends z.infer<typeof TeamLocationSchema_> {}

export const getTeamLocationsForAdmin = unaryRpc({
  name: "getTeamLocationsForAdmin" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ locations: z.array(TeamLocationSchema) }),
});
